export const BUSINESS_ORDER_TYPES = [
  { value: "new", label: "Yeni" },
  { value: "refund", label: "Müşteri Ürün İade" },
  { value: "wrongProduct", label: "Hatalı Ürün Teslimi" },
  { value: "damaged", label: "Hasarlı Ürün Gönderimi" },
  { value: "replaced", label: "Ürün Değişimi" },
  { value: "onlineReturn", label: "Online İade" },
  {
    value: "replacedQualityRelated",
    label: "Kalite Kaynaklı Ürün Değişimi",
  },
  { value: "newStoreApprovedShipment", label: "Mağaza Onaylı Gönderim" },
  { value: "promotionSeasonalCampaign", label: "Dönemsel Kampanya" },
  { value: "returnInterstoreTransfer", label: "Mağazalararası Transfer" },
  {
    value: "marketingInterstoreSalesSupport",
    label: "Mağazalararası Satış Destek",
  },
  { value: "newSpecialCustomerRequest", label: "Müşteri Özel İstek" },
  { value: "promotion", label: "Promosyon" },
  { value: "marketing", label: "Pazarlama" },
];

export const JYSK_ORDER_TYPES = [
  { value: "customerProductReplacement", label: "Müşteri Ürün Değişimi" },
  { value: "returnInterstoreTransfer", label: "Mağazalar Arası Transfer" },
  { value: "promotion", label: "Müşteriye Promosyon" },
  {
    value: "newStoreApprovedShipment",
    label: "Müşteriye Yönetici Onaylı",
  },
  { value: "other", label: "Diğer" },
];
